import Youtube from './_components/youtube';
import Vimeo from './_components/vimeo';
import Facebook from './_components/facebook';
import defaultVideo from './_components/default';
import common from './common';

export default {
    createVideo(options) {
        if (this.isYoutube(options.src)) {
            return Youtube;
        }

        if (this.isVimeo(options.src)) {
            return Vimeo;
        }

        if (this.isFacebook(options.src)) {
            return Facebook;
        }

        return defaultVideo;
    },
    isYoutube(src) {
        return common.getYoutubeId(src);
    },
    isVimeo(src) {
        return common.getVimeoId(src);
    },
    isFacebook(src) {
        let decodeUrl = decodeURIComponent(src);
        return common.getFacebookId(decodeUrl);
    }
};
